<template>

  <v-container fluid class="pb-10 page page-user-list">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-4 mb-3">
      <v-col cols="6" class="d-flex align-center justify-start">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-account-multiple</v-icon>
        <div>Org Members</div>
      </v-col>
      <v-col cols="6" align="right">
        <!-- (invite user) -->
        <v-btn color="light-blue darken-1" @click="isInviteMemberDialogOpen = true" :disabled="!canManageMembers">
          <v-icon small class="pr-2">mdi-account-plus</v-icon>
          Invite Member
        </v-btn>
      </v-col>
    </v-row>

    <!--------------------------->
    <!-- Existing Members List -->
    <!--------------------------->
    <v-row class="mt-0 mb-4">
      <v-col cols="12">
        <div class="section-title">Existing Members</div>
      </v-col>
    </v-row>

    <user-member-list-data-table :canViewDetails="canManageMembers" />

    <!--------------------------->
    <!-- Invited Members List -->
    <!--------------------------->
    <v-row class="mt-4 mb-4">
      <v-col cols="12">
        <div class="section-title">Invites</div>
      </v-col>
    </v-row>

    <user-invite-list-data-table ref="userInviteList" />

    <!-------------------------->
    <!-- Invite Member Dialog -->
    <!-------------------------->
    <v-dialog persistent max-width="850" v-model="isInviteMemberDialogOpen">
      <v-card class="invite-member-form">
        <v-card-text class="pb-0">
          <invite-sys-admin-member-form v-on:close="closeInviteMemberDialog" v-if="uiType === 'sys-admin'" />
          <invite-shipper-member-form v-on:close="closeInviteMemberDialog" v-if="uiType === 'shipper'" />
          <invite-receiver-member-form v-on:close="closeInviteMemberDialog" v-if="uiType === 'receiver'" />
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>

</template>

<script>
import UserMemberListDataTable from '@/components/users/UserMemberListDataTable'
import UserInviteListDataTable from '@/components/users/UserInviteListDataTable'
import InviteSysAdminMemberForm from '@/components/users/InviteSysAdminMemberForm'
import InviteShipperMemberForm from '@/components/users/InviteShipperMemberForm'
import InviteReceiverMemberForm from '@/components/users/InviteReceiverMemberForm'

export default {
  name: 'UserListPage',

  components: {
    UserMemberListDataTable,
    UserInviteListDataTable,
    InviteSysAdminMemberForm,
    InviteShipperMemberForm,
    InviteReceiverMemberForm
  },

  data () {
    return {
      isInviteMemberDialogOpen: false
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    canManageMembers () {
      return (
        (this.uiType === 'shipper' && this.$root.activeUserHasRole('admin')) ||
        (this.uiType === 'receiver' && this.$root.activeUserHasRole('admin')) ||
        this.uiType === 'sys-admin'
      )
    }
  },

  methods: {
    // Close invite member dialog (and determine if we need to refresh list)
    closeInviteMemberDialog (data = {}) {
      this.isInviteMemberDialogOpen = false
      if (data.invited) this.$refs.userInviteList.refresh()
    }
  }
}
</script>

<style>
  .page-user-list .section-title {
    font-size: 1.2rem;
    color: #E0E0E0;
  }

  .invite-member-form {
    background-color: #121212 !important;
  }
</style>
